export const APP_NAME = 'NAILSUPPLY.US';
export const PrefixKey = 'reviewnailsupply_';
export const DefaultLocale = process.env.APP_DEFAULT_LOCALE || 'en';
export const LocaleKey = PrefixKey + 'locale';
export const ThemeKey = PrefixKey + 'theme';
export const DefaultApiCLient = 'default';
export const AppAuthTokenKey = PrefixKey + '01';
export const AppAuthRefeshTokenKey = PrefixKey + '02';
export const AppAuthDataKey = PrefixKey + '03';
export const AppAuthTokenExpireKey = PrefixKey + '04';
export const AppAuthTokenCreatedKey = PrefixKey + '05';
export const SelectedStoreIdKey = PrefixKey + 'selected_store_id';
export const StoreTimezoneKey = PrefixKey + 'store_timezone';
export const ExpireCookieDays = 30;
export const autoRefeshTokenDays = 30;
export const SearchParamiter = '_q';
export const KeywordParamiter = '_keyword';
export const SearchMinCharactor = 1;
export const PageActionParamiter = 'crud';
export const PageIdParamiter = 'id';
export const BackendRootPath = undefined;
export const AdminRootPath = 'review';
export const CompanyIdAtt = 'companyId';
export const UserIdAtt = 'userId';
export const ProfileNameAtt = 'userProfileId';
export const CacheDateCheckKey = PrefixKey + '_cache_date_check';
export const FcmTokenKey = PrefixKey + '_mb_fcm';
export const FcmSettingKey = PrefixKey + '_mb_fcm_setting';
export const SearchHistoryKey = PrefixKey + '_searchs';
export const SucureDeviceIdAtt = '_device_jid';
export const AppDomain = 'nailsupply.us';
export const FileNamePrefix = 'app_file';
export const LatestSyncActiveStatusKey =
  PrefixKey + 'web_latest_sync_active_status';
export const MaxSelectFiles = 10;
export const LimitFileSizeMB = 50;
export const LimitFileSize = LimitFileSizeMB * 1024 * 1024;
export const UserCacheKey = PrefixKey + 'user_cache_info';
export const ShippingInfoCacheKey = PrefixKey + 'shipping_cache_info';
export const CartInfoCacheKey = PrefixKey + 'cart_cache_info';
export const OrderIdPrefix = '#Order';
export const GuestCartCacheKey = PrefixKey + 'guest_cart_info';
export const ReferralCodeKey = 'ref_code';
export const AffiliateLinkKey = PrefixKey + 'affiliate_link';
export const CacheKey = {
  YEAR_AVAILABLE: PrefixKey + 'year_available',
  LOGIN_LOG: PrefixKey + 'login_log',
};
export const specialCategorySlugs = [
  'dnd-$5.5',
  'dnd-dc-$6',
  'dnd-dip',
  'igel-dip',
  'igel-duo',
  'perfect-match',
];

export const SQUARE_CONFIG = {
  appId: 'sandbox-sq0idb-FG84KmqF3LT-4NYs6T5lOw',
  locationId: 'LZQMTQ1JJ0XGM',
  defaultCurrency: 'USD',
};

export const ImageDefault = 'https://api.nailjob.us/uploads/images/7cc8695d-046e-4db1-bc33-4ed4a9f2a17d.webp';
export const Logo = 'https://storage.googleapis.com/nailjob/uploads/68304a8bc609f2d7544507c7/398b7d8d-df68-4332-b48e-9bb3eeaadd68.webp';

export const AffiliateBaseUrl = import.meta.env.VITE_AFFILIATE_BASE_URL || 'http://localhost:9000';
